<!-- <div>
    <div class="d-flex justify-content-start align-items-center">
        <span class="pe-2"> {{ params?.value}}</span>
        <input class="pe-none" type="checkbox" [(ngModel)]="params.data.isInclTaxRC">
    </div>
</div> -->


<!-- 
<div *ngIf="params.colDef.field == 'renewalCharge'" class="d-flex  pe-3 justify-content-end">
        <span class="pe-2"> {{ params?.value}}</span>
        <input class="pe-none top check" type="checkbox" [(ngModel)]="params.data.isInclTaxRC">
  
</div>

<div  *ngIf="params.colDef.field == ''" class="d-flex pe-3 justify-content-end" (change)="onChange(params)">
        <input class="cursor-pointer check" type="checkbox" (change)="onChange(params ,checkBoxValue)" [(ngModel)]="checkBoxValue">
</div> -->

<div *ngIf="params.colDef.field == 'renewalCharge'" class="d-flex  pe-3 justify-content-end">
    <span class="pe-2"> {{ params?.value}}</span>
    <input class="pe-none top check" type="checkbox" [(ngModel)]="params.data.isInclTaxRC">

</div>

<div  *ngIf="params.colDef.field != 'renewalCharge'"  class="d-flex align-items-center justify-content-end">
    <span *ngIf="label" class="pe-2">{{ label }}</span>
    <input
      type="checkbox"
      [(ngModel)]="checkBoxValue"
      [ngClass]="{'cursor-pointer': isCursor}"
      [disabled]="disabled"
      (change)="onCheckboxChange(params ,checkBoxValue)"
      class="cursor-pointer check"
    />
  </div>